/**
 * Regroupe des lignes "longues" {xKey, groupKey, valueKey, sdKey?} en une
 * série ECharts par valeur de groupe (ex: une série par horizon/année).
 * Chaque série porte ses propres points [x, y] triés — pas besoin d'aligner
 * les x entre séries (contrairement à un format "large"), donc pas de trous
 * à gérer : chaque courbe est simplement continue sur ses propres points.
 */
export function groupSeriesXY(rows, { xKey, groupKey, valueKey, sdKey }) {
  const byGroup = new Map();
  for (const row of rows) {
    const g = row[groupKey];
    if (!byGroup.has(g)) byGroup.set(g, []);
    byGroup.get(g).push(row);
  }

  const groups = [];
  for (const [g, groupRows] of byGroup) {
    const sorted = [...groupRows].sort((a, b) => (a[xKey] > b[xKey] ? 1 : a[xKey] < b[xKey] ? -1 : 0));
    const points = sorted.map((r) => ({
      x: r[xKey],
      y: r[valueKey],
      low: sdKey != null ? r[valueKey] - r[sdKey] : undefined,
      high: sdKey != null ? r[valueKey] + r[sdKey] : undefined,
    }));
    groups.push({ group: g, points });
  }
  return groups;
}

export function toTimestamp(dateStr) {
  return new Date(dateStr).getTime();
}

export function formatDateFr(value) {
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleDateString("fr-FR", { day: "2-digit", month: "short" });
}
